export const scrollTarget = (el, binding) => {
  const { value: targetName } = binding;

  el.setAttribute('ref', targetName.replace(/\s|&/g, ''));
};
